import { Tag } from 'antd';
import moment from 'moment';
import React from 'react';

import { formatarCnpjCpfIMask } from '../../../helpers/formatador';
import colors from '../../../styles/colors';

export const getColumns = () => [
  {
    title: 'ID Lote',
    dataIndex: 'id_lote',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'Data Carregamento',
    dataIndex: 'data_emissao',
    ellipsis: true,
    sorter: true,
    render: date => moment(date).format('DD/MM/YYYY'),
  },
  {
    title: 'Tipo de Lote',
    dataIndex: 'tipo_lote',
    width: '14%',
    sorter: true,
    ellipsis: true,
    filters: [
      { text: 'Transportadora', value: 'Tradicional' },
      { text: 'Marketplace', value: 'Marketplace' },
    ],
    filterMultiple: false,
    render: tipoLote => {
      const color =
        tipoLote === 'MARKETPLACE'
          ? colors.$brandcolor_primary_dark_green
          : colors.$auxiliary_sky_2;

      return (
        <Tag color={color} key={tipoLote}>
          {tipoLote !== 'MARKETPLACE' ? 'TRANSPORTADORA' : 'MARKETPLACE'}
        </Tag>
      );
    },
  },
  {
    title: 'Origem',
    dataIndex: 'nome_municipio_origem',
    sorter: true,
    ellipsis: true,
    render: (text, object) => `${text} (${object.sigla_estado_origem})`,
  },
  {
    title: 'Destino',
    dataIndex: 'nome_municipio_destino',
    width: 80,
    sorter: true,
    ellipsis: true,
    render: (text, object) => `${text} (${object.sigla_estado_destino})`,
  },
  {
    title: 'Produto',
    dataIndex: 'produto_descricao',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'Placa',
    dataIndex: 'placa_cavalo',
    sorter: true,
  },
  {
    title: 'Motorista',
    dataIndex: 'nome_motorista',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'CPF Motorista',
    dataIndex: 'cpf_motorista',
    width: '60%',
    sorter: true,
    ellipsis: true,
    render: cpf => formatarCnpjCpfIMask(cpf),
  },
  {
    title: 'Peso',
    dataIndex: 'peso_volume',
    ellipsis: true,
    sorter: true,
    render: peso => Number(peso).toLocaleString('pt-BR'),
  },
  {
    title: 'Frete Motorista (R$/ton)',
    dataIndex: 'valor_frete_motorista',
    sorter: true,
    ellipsis: true,
    align: 'center',
    render: (value, object) => {
      if (object.tipo_lote === 'TRADICIONAL') {
        return '-';
      }

      const pesoTon = Number(object.peso_volume);
      const valorFrete = Number(value);

      return (valorFrete / (pesoTon / 1000)).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
  },
  {
    title: 'Número CTE',
    dataIndex: 'cte',
    sorter: true,
    ellipsis: true,
    render: value => {
      const [, cte] = value.split('|');
      return cte;
    },
  },
  {
    title: 'Cliente Pagador',
    dataIndex: 'cpf_cnpj_cliente',
    sorter: true,
    ellipsis: true,
    render: cnpj => formatarCnpjCpfIMask(cnpj),
  },
];
